import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./InfoBox.scss";

const InfoBox = ({ infoTitle, infoContent }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="link" className="info-box-trigger" onClick={handleShow}>
        <i className="bi bi-info-circle"></i>
      </Button>

      <Modal show={show} onHide={handleClose} dialogClassName="info-box-modal">
        <Modal.Header closeButton>
          <Modal.Title>{infoTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{infoContent}</Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
};

export default InfoBox;
